<ng-container *ngIf="viewModel$ | async as viewModel">
  <section>
    <header>
      <div class="content">
        <span class="value">{{ header }}</span>
      </div>
      <app-info-circle
        [useOverlay]="true"
        [overlayContent]="viewModel.summaryDescription"
        [renderAsButton]="true"
      ></app-info-circle>
    </header>
    <hr />

    <ng-container *ngIf="viewModel.jobLoaded; else loading">
      <main>
        <quill-editor
          format="object"
          [ngModel]="viewModel.content"
          [readOnly]="viewModel.jobNotInZone"
          [editorId]="viewModel.editorId"
          (ngModelChange)="
            store.dispatch(
              actions.summaryEditorContentChanged({
                key: viewModel.summaryKey,
                delta: $event,
              })
            )
          "
          [modules]="editModules"
          appQuillTemplateVariableToolbar
          [templatesLocations]="viewModel.templatesLocations"
          [variablesLocation]="variablesLocation"
        >
        </quill-editor>
      </main>
    </ng-container>
  </section>

  <ng-template #loading>
    <main class="p-py-3">
      <p-skeleton width="80%" height="3rem" />
    </main>
  </ng-template>
</ng-container>
